<template>
  <div id="stud_main">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>




<div style="margin-bottom:0em;" class="columns is-centered is-gapless is-mobile has-text-grey-dark doFontSmaller">
<div class="column is-3 colBorder has-text-centered has-background-grey-lighter ">Montant</div>
<div class="column is-3 colBorder has-text-centered has-background-grey-lighter ">Date du paiement</div>
<div class="column is-3 colBorder has-text-centered has-background-grey-lighter ">Recu</div>
<div class="column is-3 colBorder has-text-centered has-background-grey-lighter ">Type de paiement</div>
<!-- <div class="column is-2 colBorder has-text-centered has-background-grey-lighter ">PAI DATE</div> -->
</div>


<div style="margin-bottom:0em;" class="columns is-multiline is-centered is-gapless is-mobile has-text-grey-dark doFont" v-for ="(data, index) in data_paiments" :key="index">




<div class="column is-3 colBorder has-text-centered has-background-white">${{data.payment_Amount.toFixed(2)}}</div>
<div class="column is-3 colBorder has-text-centered has-background-white">{{ data.payment_DueDate | moment("add", "1 days","MMM-DD-Y")}}</div>

<template v-if="data.goodToGo == 1">
  <div class="column is-3 colBorder has-background-white has-text-centered has-text-success doFontSmaller"><span class="icon" style=""><i class="fas fa-thumbs-up"></i></span></div>
  <div class="column is-3 colBorder has-text-centered has-background-white">{{data.payment_RecType}}</div>
  <!-- <div class="column is-2 colBorder has-text-centered has-background-white">{{moment(data.payment_RecDate).format('MMM-DD-Y')}}</div> -->
</template>
<template v-else>
<div class="column is-3 colBorder has-background-white has-text-centered has-text-warning doFontSmaller"><span class="icon" style=""><i class="fas fa-clock"></i></span></div>
<div class="column is-3 colBorder has-text-centered has-background-grey-lighter "></div>
<!-- <div class="column is-2 colBorder has-text-centered has-background-grey-lighter "></div> -->
</template>



</div> 


  </div>
</template>


<script>
import axios from 'axios';


export default {
    props: [ 'student_id' ],

  data: function() {
    return {
        isLoading : false,

        data_paiments:[],
    }
  },


created() {
    this.get_paiments()


},

  methods: {

get_paiments() {

var query = 'SELECT *,CAST(IIF ( payment_Rec = 1, 1, 0 ) AS BIT) as goodToGo FROM MyMEQ_STUDENT_PAYMENT WHERE student_ID = ' + this.student_id
query += ' ORDER BY payment_Number'
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.data_paiments = res.data
    this.isLoading=false;
});


},




  }, // END METHODS 

} // END SCRIPT
</script>




<style scoped>



</style>
